import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'mesc-administration',
  templateUrl: './administration.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./administration.component.scss'],
})
export class MescAdministrationComponent implements OnInit {

  isAdminRoute: boolean;
  activeRoute: string;

  constructor(
    public router: Router,
    private readonly authService: AuthenticationService,
    private readonly location: Location
  ) { }

  ngOnInit() { }

  onBack = () => this.location.back();

  validateRoute = (url: string) => {
    this.activeRoute = url.split('/').pop().replace('-', ' ');
    this.isAdminRoute = this.activeRoute.toLowerCase().includes('admin');
  }

}
